import { getRecursiveArray } from 'src/helpers/getRecursiveArray';
import {
  fetchCategories,
  deleteCategory,
  updateCategory,
  fetchCategory,
  createCategory
} from '../services/napi';
import {
  CATEGORIES_FETCH_SUCCESS_ECOMMERCE,
  CATEGORY_FETCH_SUCCESS,
  CATEGORY_ENABLE_UPDATE_SUCCESS,
  CATEGORY_LOADING,
  CATEGORY_CREATE_DRAFT,
  CATEGORY_EDIT_DRAFT,
  SELECTED_CATEGORY,
  CREATE_CATEGORY_SUCCESS
} from '../constant/actionType';

export function fetchCategoriesAction() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await fetchCategories(projectId);

      const allCategories = getRecursiveArray(response.data.categories, 'children');

      dispatch({
        data: [...response.data.categories, ...allCategories],
        type: CATEGORIES_FETCH_SUCCESS_ECOMMERCE
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function createCategoryAction(data, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const { _id: parentId } = getState().categories.selectedCategory;
    const { categoryName, descriptors, categoryNameGe, type } = data;

    const body = {
      descriptors,
      name: categoryName,
      nameGe: categoryNameGe,
      parentId,
      type
      // isEnabled: true,
      // buyButton: true,
    };
    const response = await createCategory(projectId, body);
    dispatch({
      data: response.data.category,
      type: CREATE_CATEGORY_SUCCESS
    });

    onSuccess();
  };
}

export function deleteCategoryAction(categoryId, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    await deleteCategory(projectId, categoryId);
    onSuccess();
  };
}

export function fetchCategoryAction(categoryId) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await fetchCategory(projectId, categoryId);
    // eslint-disable-next-line prefer-destructuring
    response.data.category.ancestors = response.data.category.ancestors[0];
    dispatch({ data: response.data.category, type: CATEGORY_FETCH_SUCCESS });
  };
}

export function setSelectedCategoryAction(body) {
  return async (dispatch) => {
    try {
      dispatch({
        data: body,
        type: SELECTED_CATEGORY
      });
    } catch (error) {
      console.error(error);
    }
  };
}
export function setCategoryCreateDraft(body) {
  return async (dispatch) => {
    try {
      dispatch({
        data: body,
        type: CATEGORY_CREATE_DRAFT
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function setCategoryDraft(body) {
  return async (dispatch) => {
    try {
      dispatch({
        data: body,
        type: CATEGORY_EDIT_DRAFT
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function updateCategoryAction(categoryId, body, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    if (body.ancestors) {
      body.parentId = body.ancestors._id;
    }
    delete body.ancestors;
    const response = await updateCategory(projectId, categoryId, body);
    dispatch({
      data: response.data.profile,
      type: CATEGORY_ENABLE_UPDATE_SUCCESS
    });

    onSuccess();
  };
}

export function cleanupAction() {
  return (dispatch) => {
    dispatch({
      type: CATEGORY_LOADING
    });
  };
}
